import { useSearchParams } from 'react-router-dom';

/**
 * Reads the `?search=` term the global palette navigates with, so a list page opens
 * already filtered to the row the user picked. Returns null when absent or empty so
 * callers can keep their existing `null` default.
 */
export function useUrlSearchFilter(): string | null {
  const [searchParams] = useSearchParams();
  const value = searchParams.get('search');
  return value && value.length > 0 ? value : null;
}
